<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$helpers.getUplineName($store.getters.accountType-1) + " " + $t("ui.list")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.account_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="account_id"
                    :placeholder='$t("ui.account_id")'
                    v-model="account_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                b-input-group(:prepend="$t('ui.status')" size="sm")
                  b-form-select(
                    ref="status"
                    v-model="status"
                    :options="$helpers.getStatusList()"
                    size="sm"
                    @change="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            //- b-row
            //-   .col-sm-12.col-md-12.col-lg-12.col-xl-12
            //-     .alert.alert-warning.mb-1 {{ $t("message.jackpot_alert") }}
            template(v-if="$helpers.getVisible(editAccount)")
              b-row(:class="{ 'd-none' : $store.getters.accountStatus == 'SUSPEND' }")
                .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                  b-button(type="button" variant="warning" size="sm" to="/newAccount")
                    i.fa.fa-plus.mr-1
                    span {{ $t("ui.new") + ' ' + $helpers.getUplineName($store.getters.accountType-1) }}
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.tblAgent.table-sm.table-hover.table-bordered(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="agentList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged" :tbody-tr-class="rowClass")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(account_id)="row")
                    .d-flex
                      b-link.mr-1(v-show="!$helpers.isAgentLevel()" @click="redirectTo(row.item, 'viewDownline')" style="text-decoration:none;") #[b {{ row.item.account_id.toUpperCase() }}]
                      span.mr-1(v-show="$helpers.isAgentLevel()") #[b {{ row.item.account_id.toUpperCase() }}]
                      .ml-auto(v-if="$helpers.getVisible(editAccount)")
                        a.fas.fa-lg.fa-fw.fa-copy.text-dark.mt-1(
                          @click="copy(row.item, 'newAccount?id=searchCopy')"
                          :title="$t('ui.copy')"
                          style="cursor: pointer;float:right;"
                        )
                  template(v-slot:cell(login_id)="row")
                    span(v-if="row.item.login_id") {{ row.item.login_id.toUpperCase() }}
                  template(v-slot:cell(status)="row")
                    div.d-flex.flex-nowrap(style="justify-content: center;")
                      template(v-if="row.item.profile_status == 'BLOCK'")
                        SubmitButton(:loading="loading" size="sm" icon="fa fa-times" :text="$t('ui.block')" isModal=false type="button" variant="danger" @click="unblockProfile(row.item)" :disabled="$helpers.isSuspended()")
                      template(v-else)
                        template(v-if="$helpers.isSuspended()")
                          b-form-select(
                            size="sm"
                            v-model="row.item.status"
                            disabled
                          )
                            option(value="ACTIVE") {{ $t("ui.active") }}
                            option(value="CLOSE") {{ $t("ui.close") }}
                            option(value="SUSPEND") {{ $t("ui.suspend") }}
                        template(v-else)
                          b-form-select(
                            size="sm"
                            v-model="row.item.status"
                            @change="updateStatus(row.item, $event)"
                            :disabled="!$helpers.getVisible(editAccount)"
                            :style="{ background: row.item.status == 'SUSPEND' ? '#fce3bf' : row.item.status == 'CLOSE' ? '#ffd1d0' : '' }"
                          )
                            template(v-if="row.item.status == 'FREEZE'")
                              option(
                                value="FREEZE"
                                :disabled="row.item.status == 'FREEZE'"
                              ) {{ $t("ui.freeze") }}
                            template(v-else)
                              option(
                                value="ACTIVE"
                                :disabled="row.item.status == 'ACTIVE'"
                              ) {{ $t("ui.active") }}
                              option(
                                value="CLOSE"
                                :disabled="row.item.status == 'CLOSE'"
                              ) {{ $t("ui.close") }}
                              option(
                                value="SUSPEND"
                                :disabled="row.item.status == 'CLOSE' || row.item.status == 'SUSPEND'"
                              ) {{ $t("ui.suspend") }}
                  template(v-slot:cell(cash_balance)="row")
                    span(:class="$helpers.getNumberClass(row.item.cash_balance)") {{ Math.floor(row.item.cash_balance * 100) / 100 | currency }}
                  template(v-slot:cell(remaining_credit)="row")
                    span(v-if="!$helpers.isMemberLevel(row.item.account_type)" :class="$helpers.getNumberClass(row.item.credit_limit - row.item.used_credit)") {{ row.item.credit_limit - row.item.used_credit | currency }}
                    span(v-if="$helpers.isMemberLevel(row.item.account_type)" :class="$helpers.getNumberClass(row.item.available_credit)") {{ row.item.available_credit | currency }}
                  template(v-slot:cell(credit_limit)="row")
                    span(:class="$helpers.getNumberClass(row.item.credit_limit)") {{ row.item.credit_limit | currency }}
                  template(v-slot:cell(created_date)="row")
                    span {{ $moment(row.item.created_date).format("YYYY-MM-DD HH:mm:ss") }}
                  template(v-slot:cell(action)="row")
                    div.d-flex.flex-nowrap(style="justify-content: center;")
                      b-button-group
                        template(v-if="$helpers.getVisible(editAccount)")
                          span
                            a.fas.fa-lg.fa-fw.fa-search.text-dark.mt-1(
                              @click="redirectTo(row.item, 'search')"
                              :title="$t('ui.search')"
                              style="cursor: pointer;float:right;"
                            )
                          span
                            template(v-if="$helpers.isSuspended()")
                              a.fas.fa-lg.fa-fw.fa-edit.text-primary(
                                style="cursor: pointer;"
                              )
                            template(v-else)
                              a.fas.fa-lg.fa-fw.fa-edit.text-primary(
                                v-b-modal.updateProfile
                                @click="setEditSelectedModal(row.item)"
                                :title="$t('ui.edit')"
                                style="cursor: pointer;"
                              )
                          span
                            template(v-if="$helpers.isSuspended()")
                              a.fas.fa-lg.fa-fw.fa-lock.text-warning(
                                style="cursor: pointer;"
                              )
                            template(v-else)
                              a.fas.fa-lg.fa-fw.fa-lock.text-warning(
                                v-b-modal.resetPassword
                                @click="setEditSelectedModal(row.item)"
                                :title="$t('ui.password')"
                                style="cursor: pointer;"
                              )
                          span
                            template(v-if="$helpers.isSuspended()")
                              a.fas.fa-lg.fa-fw.fa-cog.text-dark(
                                style="cursor: pointer;"
                              )
                            template(v-else)
                              a.fas.fa-lg.fa-fw.fa-cog.text-dark(
                                v-b-modal.settings
                                @click="setEditSelectedModal(row.item)"
                                :title="$t('ui.platform_settings')"
                                style="cursor: pointer;"
                              )
                        span(v-if="$helpers.getVisible(report)")
                          a.fas.fa-lg.fa-fw.fa-chart-area.text-info(
                            @click="redirectTo(row.item, 'dailyWinlose')"
                            :title="$t('ui.daily_winlose')"
                            style="cursor: pointer;"
                          )
                        b-dropdown.setting(
                          role="button"
                          size="sm"
                          :title="$t('ui.settings')"
                          variant="link"
                          dropdown
                        )
                          template(slot="button-content")
                            i.fas.fa-lg.fa-fw.fa-sliders-h
                          .accordion(:id="'accordion-' + row.index")
                            b-dropdown-group
                              b-dropdown-header.dropdownhead.collapsed(data-toggle='collapse', :data-target="'#accordion-pt' + row.index", aria-expanded='false') {{ $t("ui.position_taking") }}
                              .collapse(:id="'accordion-pt' + row.index" :data-parent="'#accordion-' + row.index")
                                b-dropdown-item-button(v-b-modal.updatePTSB @click="setEditSelectedModal(row.item)") {{ $t("ui.sportsbook") }}
                                b-dropdown-item-button(v-if="['MMK','MMO'].includes($store.getters.getAccountCurrency)" v-b-modal.updatePTMMO @click="setEditSelectedModal(row.item)") {{ $t("ui.sportsbook") }} MMO
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('SL')" v-b-modal.updatePTSL @click="setEditSelectedModal(row.item)") {{ $t("ui.slot_games") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('LC')" v-b-modal.updatePTLC @click="setEditSelectedModal(row.item)") {{ $t("ui.live_casino") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('LO')" v-b-modal.updatePTLO @click="setEditSelectedModal(row.item)") {{ $t("ui.lotto") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('KNno')" v-b-modal.updatePTKN @click="setEditSelectedModal(row.item)") {{ $t("ui.keno") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('CF')" v-b-modal.updatePTCF @click="setEditSelectedModal(row.item)") {{ $t("ui.esports2") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('LTno')" v-b-modal.updatePTLT @click="setEditSelectedModal(row.item)") {{ $t("ui.lottery") }}
                            b-dropdown-group
                              b-dropdown-header.dropdownhead.collapsed(data-toggle='collapse', :data-target="'#accordion-cm' + row.index", aria-expanded='false') {{ $t("ui.commission") }}
                              .collapse(:id="'accordion-cm' + row.index" :data-parent="'#accordion-' + row.index")
                                b-dropdown-item-button(v-b-modal.updateCMSB @click="setEditSelectedModal(row.item)") {{ $t("ui.sportsbook") }}
                                b-dropdown-item-button(v-if="['MMK','MMO'].includes($store.getters.getAccountCurrency)" v-b-modal.updateCMMMO @click="setEditSelectedModal(row.item)") {{ $t("ui.sportsbook") }} MMO
                                //- b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('SL')" v-b-modal.updateCMSL @click="setEditSelectedModal(row.item)") {{ $t("ui.slot_games") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('LC')" v-b-modal.updateCMLC @click="setEditSelectedModal(row.item)") {{ $t("ui.live_casino") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('LO')" v-b-modal.updateCMLO @click="setEditSelectedModal(row.item)") {{ $t("ui.lotto") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('KNno')" v-b-modal.updateCMKN @click="setEditSelectedModal(row.item)") {{ $t("ui.keno") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('CF')" v-b-modal.updateCMCF @click="setEditSelectedModal(row.item)") {{ $t("ui.esports2") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('LT')" v-b-modal.updateCMLT @click="setEditSelectedModal(row.item)") {{ $t("ui.lottery") }}
                                template(v-if="!$helpers.isAgentLevel()")
                                  b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('KN')" v-b-modal.updateCMTN @click="setEditSelectedModal(row.item)") {{ $t("ui.tournament") }}
                            b-dropdown-group
                              b-dropdown-header.dropdownhead.collapsed(data-toggle='collapse', :data-target="'#accordion-bl' + row.index", aria-expanded='false') {{ $t("ui.bet_limit") }}
                              .collapse(:id="'accordion-bl' + row.index" :data-parent="'#accordion-' + row.index")
                                b-dropdown-item-button(v-b-modal.updateBLSB @click="setEditSelectedModal(row.item)") {{ $t("ui.sportsbook") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('LC')" v-b-modal.updateBLLC @click="setEditSelectedModal(row.item)") {{ $t("ui.live_casino") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('LO')" v-b-modal.updateBLLO @click="setEditSelectedModal(row.item)") {{ $t("ui.lotto") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('KNno')" v-b-modal.updateBLKN @click="setEditSelectedModal(row.item)") {{ $t("ui.keno") }}
                                //- b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('CF')" v-b-modal.updateBLCF @click="setEditSelectedModal(row.item)") {{ $t("ui.esports2") }}
                                b-dropdown-item-button(v-if="$helpers.isPlatformEnabled('LT')" v-b-modal.updateBLLT @click="setEditSelectedModal(row.item)") {{ $t("ui.lottery") }}
                        span.ml-1(v-if="['MMK','MMO'].includes($store.getters.getAccountCurrency) && $helpers.getVisible(settlement)")
                          a.fas.fa-lg.fa-fw.fa-money-check.text-dark(
                            v-b-modal.transferCash
                            @click="setEditSelectedModal(row.item)"
                            :title="$t('ui.transfer')"
                            style="cursor: pointer;"
                          )

      settings(:accountId="updateAccountID")
      resetPassword(:accountId="updateAccountID" :accountType="updateAccountType")
      updateProfile(:accountId="updateAccountID" :accountType="updateAccountType" @clicked="submit")
      updatePTSB(:accountId="updateAccountID")
      updatePTMMO(:accountId="updateAccountID")
      updatePTSL(:accountId="updateAccountID")
      updatePTLC(:accountId="updateAccountID")
      updatePTLO(:accountId="updateAccountID")
      updatePTKN(:accountId="updateAccountID")
      updatePTCF(:accountId="updateAccountID")
      updatePTLT(:accountId="updateAccountID")
      updateCMSB(:accountId="updateAccountID")
      updateCMMMO(:accountId="updateAccountID")
      updateCMLC(:accountId="updateAccountID")
      //- updateCMSL(:accountId="updateAccountID")
      updateCMLO(:accountId="updateAccountID")
      updateCMKN(:accountId="updateAccountID")
      updateCMCF(:accountId="updateAccountID")
      updateCMLT(:accountId="updateAccountID")
      updateCMTN(:accountId="updateAccountID")
      updateBLSB(:accountId="updateAccountID")
      updateBLLC(:accountId="updateAccountID")
      updateBLLO(:accountId="updateAccountID")
      updateBLKN(:accountId="updateAccountID")
      updateBLCF(:accountId="updateAccountID")
      updateBLLT(:accountId="updateAccountID")

      transferCash(:accountID="updateAccountID" :currentBalance="balance"  @clicked="submit")

</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton"
import resetPassword from "@/components/modal/resetPassword.vue"
import settings from "@/components/modal/settings.vue"
import updateProfile from "@/components/modal/updateProfile.vue"
import currency from "@/components/settings/currency.vue"
import DebounceInput from "@/library/DebounceInput"
import updatePTSB from "@/components/settings/updatePTSB.vue"
import updatePTMMO from "@/components/settings/updatePTMMO.vue"
import updatePTSL from "@/components/settings/updatePTSL.vue"
import updatePTLC from "@/components/settings/updatePTLC.vue"
import updatePTLO from "@/components/settings/updatePTLO.vue"
import updatePTKN from "@/components/settings/updatePTKN.vue"
import updatePTCF from "@/components/settings/updatePTCF.vue"
import updatePTLT from "@/components/settings/updatePTLT.vue"

import updateCMSB from "@/components/settings/updateCMSB.vue"
import updateCMMMO from "@/components/settings/updateCMMMO.vue"
import updateCMLC from "@/components/settings/updateCMLC.vue"
// import updateCMSL from "@/components/settings/updateCMSL.vue"
import updateCMLO from "@/components/settings/updateCMLO.vue"
import updateCMKN from "@/components/settings/updateCMKN.vue"
import updateCMCF from "@/components/settings/updateCMCF.vue"
import updateCMLT from "@/components/settings/updateCMLT.vue"
import updateCMTN from "@/components/settings/updateCMTN.vue"

import updateBLSB from "@/components/settings/updateBLSB.vue"
import updateBLLC from "@/components/settings/updateBLLC.vue"
import updateBLLO from "@/components/settings/updateBLLO.vue"
import updateBLKN from "@/components/settings/updateBLKN.vue"
import updateBLCF from "@/components/settings/updateBLCF.vue"
import updateBLLT from "@/components/settings/updateBLLT.vue"


import transferCash from "@/components/modal/transferCash.vue"

export default {
  components: {
    SubmitButton,
    resetPassword,
    settings,
    updateProfile,
    currency,
    DebounceInput,
    updatePTSB,
    updatePTMMO,
    updatePTSL,
    updatePTLC,
    updatePTLO,
    updatePTKN,
    updatePTCF,
    updatePTLT,
    updateCMSB,
    updateCMMMO,
    updateCMLC,
    // updateCMSL,
    updateCMLO,
    updateCMKN,
    updateCMCF,
    updateCMLT,
    updateCMTN,
    updateBLSB,
    updateBLLC,
    updateBLLO,
    updateBLKN,
    updateBLCF,
    updateBLLT,
    transferCash
  },
  data() {
    return {
      account_id: "",
      agentList: [],
      updateAccountID: "",
      updateAccountType: "",
      balance: 0,
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      filter: null,
      sortBy: "account_id",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0,
      status: "active"
    }
  },
  validations: {},
  computed: {
    editAccount() {
      return [config.accessRoles.editAccount]
    },
    report() {
      return [config.accessRoles.report]
    },
    settlement() {
      return [config.accessRoles.settlement]
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "login_id",
          label: this.$t("ui.login_id"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "full_name",
          label: this.$t("ui.full_name"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "contact_phone",
          label: this.$t("ui.contact_phone"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "8%"
          }
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          class: "align-middle text-center",
          thClass: "bg-grey"
        },
        {
          key: "cash_balance",
          label: this.$t("ui.current_balance"),
          class: "align-middle text-right " + this.isMMK(),
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "remaining_credit",
          label: this.$t("ui.remaining_credit"),
          class: "align-middle text-right",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "credit_limit",
          label: this.$t("ui.credit_limit"),
          class: "align-middle text-right",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "align-middle text-center m-110",
          thClass: "bg-grey",
          thStyle: {
            width: "8%"
          }
        },
        {
          key: "last_login_ip",
          label: this.$t("ui.login_ip"),
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "6%"
          }
        },
        {
          key: "created_date",
          label: this.$t("ui.created_on"),
          class: "align-middle text-right",
          thClass: "bg-grey",
          thStyle: {
            width: "8%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function(){
    this.$helpers.getPlatform()
    this.submit()
  },
  methods: {
    isMMK() {
      return (['MMK','MMO'].includes(this.$store.getters.getAccountCurrency)) ? "" : "d-none"
    },
    searchFrom: function() {
      if(this.search_id != this.$store.getters.accountID) {
        this.$store.dispatch("user/setSelectedID", this.search_id)
        this.$router.push("/search").catch(err=>{})
      }
    },
    rowClass(item, type) {
      if (!item) return
      if (item.status === 'SUSPEND') return 'table-warning'
      if (item.status === 'CLOSE') return 'table-danger'
      if (item.status === 'FREEZE') return 'table-primary'
    },
    redirectTo: function(account, page) {
      if(account.account_type > 1 || page == 'search'){
        this.$store.dispatch("user/setSelectedID", account.account_id)
        this.$store.dispatch("user/setSelectedType", account.account_type)
      }
      this.$router.push("/" + page)
    },
    copy: function(account, page) {
      this.$store.dispatch("user/setSelectedID", account.account_id)
      this.$store.dispatch("user/setSelectedType", account.account_type)
      this.$router.push("/" + page)
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable()
    },
    refreshTable() {
      this.$root.$emit("bv::table::refresh", "tblList")
    },
    setEditSelectedModal: function(account) {
      this.updateAccountID = account.account_id
      this.updateAccountType = account.account_type
      this.balance = account.cash_balance ? Math.floor(account.cash_balance * 100) / 100 : 0
    },
    unblockProfile: function(account) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.unblock_account_profile_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          let profile_id = account.profile_id
          this.loading = true
          this.$store
            .dispatch("user/unblockProfile", { profile_id })
            .then(response => {
              this.loading = false
              this.submission.success = response.success
              // this.submission.status = response.errorTag
              if (this.submission.success == true) {
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.unblock_account_profile_success"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    this.submit();
                  }
                });
              }
            })
            .catch(response => {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = this.$t("message." + response.errorTag)
            });
        } else if (
          // Read more about handling dismissals
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.unblock_account_profile_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.submit()
            }
          });
        }
      });
    },
    updateStatus: function(account, status) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.update_account_status_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          let account_id = account.account_id
          this.loading = true
          this.$store
            .dispatch("user/updateStatus", { account_id, status })
            .then(response => {
              this.loading = false
              this.submission.success = response.success
              // this.submission.status = response.errorTag
              if (this.submission.success == true) {
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.update_account_status_success"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    this.submit();
                  }
                });
              }
            })
            .catch(response => {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = this.$t("message." + response.errorTag)
            });
        } else if (
          // Read more about handling dismissals
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.update_account_status_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.submit()
            }
          });
        }
      });
    },
    submit: function() {
      if(this.$helpers.isAgentLevel()) {
        this.getMemberList()
      } else {
        this.getDownlineList()
      }
    },
    getDownlineList: function() {
      if (!this.$v.$invalid) {
        let search_id = this.account_id
        let target_account_id = this.$store.getters.accountID
        let start_date = "";//(this.dateRange[0] != null) ? ((this.dateRange[0] != "") ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
        let end_date = "";//(this.dateRange[1] != null) ? ((this.dateRange[1] != "") ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        let status = this.status
        this.loading = true
        this.$store
          .dispatch("user/getAccountList", { search_id, target_account_id, status, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.loading = false
            this.submission.success = response.success;
            // this.submission.status = response.errorTag;
            if (this.submission.success == true) {
              this.agentList = response.data
              this.totalRows = response.data.length > 0 ? this.agentList[0]["totalrows"] : 0;
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag);
          });
      }
    },
    getMemberList: function() {
      if (!this.$v.$invalid) {
        let search_id = this.account_id
        let target_account_id = this.$store.getters.accountID
        let start_date = "";//(this.dateRange[0] != null) ? ((this.dateRange[0] != "") ? this.$(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
        let end_date = "";//(this.dateRange[1] != null) ? ((this.dateRange[1] != "") ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        let status = this.status
        this.loading = true
        this.$store
          .dispatch("user/getMemberList", { search_id, target_account_id, status, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.loading = false
            this.submission.success = response.success;
            // this.submission.status = response.errorTag;
            if (this.submission.success == true) {
              this.agentList = response.data
              this.totalRows = response.data.length > 0 ? this.agentList[0]["totalrows"] : 0;
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag);
          });
      }
    }
  }
}
</script>